import React from 'react';
import { AreaChart, Area, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from 'recharts';

const mockData = [
  { month: 'Jan', revenue: 4000 },
  { month: 'Feb', revenue: 3000 },
  { month: 'Mar', revenue: 5000 },
  { month: 'Apr', revenue: 4600 },
  { month: 'May', revenue: 5500 },
  { month: 'Jun', revenue: 4800 },
];

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    return (
      <div style={{
        background: '#ffffff',
        border: '1px solid #e5e7eb',
        borderRadius: '8px',
        padding: '10px 14px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
        fontFamily: 'Inter, sans-serif'
      }}>
        <p style={{ margin: 0, fontWeight: 600, color: '#374151', fontSize: '13px' }}>{label}</p>
        <p style={{ margin: '4px 0 0', color: '#0284c7', fontWeight: 700, fontSize: '14px' }}>
          Revenue: ${payload[0].value.toLocaleString()}
        </p>
      </div>
    );
  }
  return null;
};

const RevenueTrendChart = () => (
  <ResponsiveContainer width="100%" height={260}>
    <AreaChart data={mockData} margin={{ top: 20, right: 20, left: 0, bottom: 5 }}>
      <defs>
        <linearGradient id="revenueGrad" x1="0" y1="0" x2="0" y2="1">
          <stop offset="5%" stopColor="#0284c7" stopOpacity={0.4} />
          <stop offset="95%" stopColor="#0284c7" stopOpacity={0.0} />
        </linearGradient>
      </defs>
      <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" vertical={false} />
      <XAxis dataKey="month" tickLine={false} axisLine={{ stroke: '#cbd5e1' }} tick={{ fill: '#64748b', fontSize: 12 }} />
      <YAxis tickLine={false} axisLine={false} tick={{ fill: '#64748b', fontSize: 12 }} tickFormatter={(val) => `$${val}`} />
      <Tooltip content={<CustomTooltip />} />
      <Area type="monotone" dataKey="revenue" stroke="#0284c7" strokeWidth={3} fillOpacity={1} fill="url(#revenueGrad)" />
    </AreaChart>
  </ResponsiveContainer>
);

export default RevenueTrendChart;
